import React, { FunctionComponent } from 'react'
import { useTranslation } from 'next-i18next'
import { Button, useIsCashTheme } from '@afterpaytouch/core'
import { useAmplitudeWithEnduringEventProperties } from '../../../integrations/amplitude'
import { TrackingEvent } from '../../../model/amplitude'

const I18N_NAMESPACE = ['common', 'orders']

interface PayNowButtonProps {
  orderId: string
  outboundLink: string
  onClick: () => void
}

export const PayNowButton: FunctionComponent<PayNowButtonProps> = ({ orderId, outboundLink, onClick = () => {} }) => {
  const isCashTheme = useIsCashTheme()
  const { t } = useTranslation(I18N_NAMESPACE)
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  return (
    <>
      <Button
        kind={isCashTheme ? 'Primary' : 'Secondary'}
        testNameSpace='paynow-payment'
        onClick={() => {
          onClick()
          logEvent(TrackingEvent.CLICKED_MAKE_A_PAYMENT, {
            orderId,
            outboundLink,
          })
        }}
        padding='Fluid'
      >
        {t('orders:customPayment:cta')}
      </Button>
    </>
  )
}
